import { jsx as _jsx } from "react/jsx-runtime";
import dynamic from 'next/dynamic';
import { useMemo } from 'react';
import { ErrorBoundary } from '..';
/**
 * A fallback component that renders nothing.
 */
const FallbackComponent = () => {
    return null;
};
/**
 * Wrapper around dynamic import.
 * Adds error boundaries and fallback options.
 */
export function RemoteComponent({ dynamicImporter, fallback = () => Promise.resolve(FallbackComponent), customBoundary: CustomBoundary = ErrorBoundary, ...rest }) {
    const ImportResult = useMemo(() => {
        return dynamic(() => dynamicImporter().catch((e) => {
            console.error(e);
            return fallback();
        }), {
            ssr: false,
        });
    }, [dynamicImporter, fallback]);
    return (_jsx(CustomBoundary, { children: _jsx(ImportResult, { ...rest }) }));
}
